import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    issueNumber: {
        display: "flex",
        alignItems: "center",
        gap: theme.spacing(2),
        fontSize: "14px",
        fontFamily: "Open Sans",
    },
    form: {
        marginTop: "16px",
        marginBottom: "66px",
    },
    divider: {
        width: "100%",
    },
    content: {
        padding: `${theme.spacing(6)} ${theme.spacing(8)}`,
    },
}));
